// 회계 관리 목업 데이터 - 농산물 박스 제조업

import type {
  Account,
  JournalEntry,
  PaymentEntry,
  BankTransaction,
} from '../types';

// 계정과목
export const accounts: Account[] = [
  // 자산 계정
  {
    id: 'ACC001',
    code: '1000',
    name: '자산',
    accountType: 'asset',
    isGroup: true,
    balance: 0,
    currency: 'KRW',
    isActive: true,
  },
  {
    id: 'ACC002',
    code: '1100',
    name: '유동자산',
    accountType: 'asset',
    parentId: 'ACC001',
    isGroup: true,
    balance: 0,
    currency: 'KRW',
    isActive: true,
  },
  {
    id: 'ACC003',
    code: '1110',
    name: '현금',
    accountType: 'asset',
    subType: 'cash',
    parentId: 'ACC002',
    isGroup: false,
    balance: 12000000,
    currency: 'KRW',
    isActive: true,
  },
  {
    id: 'ACC004',
    code: '1120',
    name: '보통예금 - 농협은행',
    accountType: 'asset',
    subType: 'bank',
    parentId: 'ACC002',
    isGroup: false,
    balance: 95000000,
    currency: 'KRW',
    isActive: true,
  },
  {
    id: 'ACC005',
    code: '1130',
    name: '보통예금 - 기업은행',
    accountType: 'asset',
    subType: 'bank',
    parentId: 'ACC002',
    isGroup: false,
    balance: 48000000,
    currency: 'KRW',
    isActive: true,
  },
  {
    id: 'ACC006',
    code: '1200',
    name: '매출채권',
    accountType: 'asset',
    subType: 'receivable',
    parentId: 'ACC002',
    isGroup: false,
    balance: 42500000,
    currency: 'KRW',
    isActive: true,
  },
  {
    id: 'ACC007',
    code: '1300',
    name: '재고자산',
    accountType: 'asset',
    subType: 'stock',
    parentId: 'ACC002',
    isGroup: false,
    balance: 68000000,
    currency: 'KRW',
    isActive: true,
  },
  {
    id: 'ACC008',
    code: '1500',
    name: '고정자산',
    accountType: 'asset',
    parentId: 'ACC001',
    isGroup: true,
    balance: 0,
    currency: 'KRW',
    isActive: true,
  },
  {
    id: 'ACC009',
    code: '1510',
    name: '공장건물',
    accountType: 'asset',
    subType: 'fixed_asset',
    parentId: 'ACC008',
    isGroup: false,
    balance: 280000000,
    currency: 'KRW',
    isActive: true,
  },
  {
    id: 'ACC010',
    code: '1520',
    name: '제조설비 (인쇄기/제함기)',
    accountType: 'asset',
    subType: 'fixed_asset',
    parentId: 'ACC008',
    isGroup: false,
    balance: 150000000,
    currency: 'KRW',
    isActive: true,
  },
  {
    id: 'ACC011',
    code: '1530',
    name: '운반차량',
    accountType: 'asset',
    subType: 'fixed_asset',
    parentId: 'ACC008',
    isGroup: false,
    balance: 45000000,
    currency: 'KRW',
    isActive: true,
  },

  // 부채 계정
  {
    id: 'ACC020',
    code: '2000',
    name: '부채',
    accountType: 'liability',
    isGroup: true,
    balance: 0,
    currency: 'KRW',
    isActive: true,
  },
  {
    id: 'ACC021',
    code: '2100',
    name: '유동부채',
    accountType: 'liability',
    parentId: 'ACC020',
    isGroup: true,
    balance: 0,
    currency: 'KRW',
    isActive: true,
  },
  {
    id: 'ACC022',
    code: '2110',
    name: '매입채무',
    accountType: 'liability',
    subType: 'payable',
    parentId: 'ACC021',
    isGroup: false,
    balance: 45000000,
    currency: 'KRW',
    isActive: true,
  },
  {
    id: 'ACC023',
    code: '2120',
    name: '미지급금',
    accountType: 'liability',
    subType: 'current_liability',
    parentId: 'ACC021',
    isGroup: false,
    balance: 15000000,
    currency: 'KRW',
    isActive: true,
  },
  {
    id: 'ACC024',
    code: '2130',
    name: '예수금',
    accountType: 'liability',
    subType: 'current_liability',
    parentId: 'ACC021',
    isGroup: false,
    balance: 9500000,
    currency: 'KRW',
    isActive: true,
  },
  {
    id: 'ACC025',
    code: '2200',
    name: '장기부채',
    accountType: 'liability',
    parentId: 'ACC020',
    isGroup: true,
    balance: 0,
    currency: 'KRW',
    isActive: true,
  },
  {
    id: 'ACC026',
    code: '2210',
    name: '장기차입금 (설비투자)',
    accountType: 'liability',
    subType: 'long_term_liability',
    parentId: 'ACC025',
    isGroup: false,
    balance: 120000000,
    currency: 'KRW',
    isActive: true,
  },

  // 자본 계정
  {
    id: 'ACC030',
    code: '3000',
    name: '자본',
    accountType: 'equity',
    isGroup: true,
    balance: 0,
    currency: 'KRW',
    isActive: true,
  },
  {
    id: 'ACC031',
    code: '3100',
    name: '자본금',
    accountType: 'equity',
    subType: 'capital',
    parentId: 'ACC030',
    isGroup: false,
    balance: 450000000,
    currency: 'KRW',
    isActive: true,
  },
  {
    id: 'ACC032',
    code: '3200',
    name: '이익잉여금',
    accountType: 'equity',
    subType: 'retained_earnings',
    parentId: 'ACC030',
    isGroup: false,
    balance: 101000000,
    currency: 'KRW',
    isActive: true,
  },

  // 수익 계정
  {
    id: 'ACC040',
    code: '4000',
    name: '수익',
    accountType: 'income',
    isGroup: true,
    balance: 0,
    currency: 'KRW',
    isActive: true,
  },
  {
    id: 'ACC041',
    code: '4100',
    name: '박스 매출',
    accountType: 'income',
    subType: 'sales',
    parentId: 'ACC040',
    isGroup: false,
    balance: 185000000,
    currency: 'KRW',
    isActive: true,
  },
  {
    id: 'ACC042',
    code: '4200',
    name: '영업외수익',
    accountType: 'income',
    subType: 'other_income',
    parentId: 'ACC040',
    isGroup: false,
    balance: 2500000,
    currency: 'KRW',
    isActive: true,
  },

  // 비용 계정
  {
    id: 'ACC050',
    code: '5000',
    name: '비용',
    accountType: 'expense',
    isGroup: true,
    balance: 0,
    currency: 'KRW',
    isActive: true,
  },
  {
    id: 'ACC051',
    code: '5100',
    name: '원재료비 (원지/골판지)',
    accountType: 'expense',
    subType: 'cost_of_goods_sold',
    parentId: 'ACC050',
    isGroup: false,
    balance: 95000000,
    currency: 'KRW',
    isActive: true,
  },
  {
    id: 'ACC052',
    code: '5200',
    name: '급여',
    accountType: 'expense',
    subType: 'operating_expense',
    parentId: 'ACC050',
    isGroup: false,
    balance: 32000000,
    currency: 'KRW',
    isActive: true,
  },
  {
    id: 'ACC053',
    code: '5300',
    name: '공장 임차료',
    accountType: 'expense',
    subType: 'operating_expense',
    parentId: 'ACC050',
    isGroup: false,
    balance: 6000000,
    currency: 'KRW',
    isActive: true,
  },
  {
    id: 'ACC054',
    code: '5400',
    name: '감가상각비',
    accountType: 'expense',
    subType: 'operating_expense',
    parentId: 'ACC050',
    isGroup: false,
    balance: 8000000,
    currency: 'KRW',
    isActive: true,
  },
  {
    id: 'ACC055',
    code: '5500',
    name: '부자재비 (잉크/풀)',
    accountType: 'expense',
    subType: 'operating_expense',
    parentId: 'ACC050',
    isGroup: false,
    balance: 12000000,
    currency: 'KRW',
    isActive: true,
  },
  {
    id: 'ACC056',
    code: '5600',
    name: '이자비용',
    accountType: 'expense',
    subType: 'other_expense',
    parentId: 'ACC050',
    isGroup: false,
    balance: 4500000,
    currency: 'KRW',
    isActive: true,
  },
];

// 분개
export const journalEntries: JournalEntry[] = [
  {
    id: 'JE001',
    code: 'JE-2025-001',
    entryDate: '2025-01-05',
    status: 'submitted',
    entryType: '매출분개',
    items: [
      {
        id: 'JEI001',
        accountId: 'ACC006',
        accountCode: '1200',
        accountName: '매출채권',
        debit: 8800000,
        credit: 0,
        description: '서귀포감귤농협 감귤박스 매출',
      },
      {
        id: 'JEI002',
        accountId: 'ACC041',
        accountCode: '4100',
        accountName: '박스 매출',
        debit: 0,
        credit: 8000000,
        description: '감귤박스 10kg/20kg 판매',
      },
      {
        id: 'JEI003',
        accountId: 'ACC024',
        accountCode: '2130',
        accountName: '예수금',
        debit: 0,
        credit: 800000,
        description: '부가세 예수금',
      },
    ],
    totalDebit: 8800000,
    totalCredit: 8800000,
    reference: 'INV-2025-001',
    remarks: '서귀포감귤농협 감귤박스 매출',
    createdBy: '김회계',
    createdAt: '2025-01-05',
    updatedAt: '2025-01-05',
  },
  {
    id: 'JE002',
    code: 'JE-2025-002',
    entryDate: '2025-01-10',
    status: 'submitted',
    entryType: '매입분개',
    items: [
      {
        id: 'JEI004',
        accountId: 'ACC007',
        accountCode: '1300',
        accountName: '재고자산',
        debit: 15000000,
        credit: 0,
        description: '골판지 원단 매입',
      },
      {
        id: 'JEI005',
        accountId: 'ACC022',
        accountCode: '2110',
        accountName: '매입채무',
        debit: 0,
        credit: 15000000,
        description: '(주)한국제지',
      },
    ],
    totalDebit: 15000000,
    totalCredit: 15000000,
    reference: 'PO-2025-001',
    remarks: '골판지 원단 매입',
    createdBy: '김회계',
    createdAt: '2025-01-10',
    updatedAt: '2025-01-10',
  },
  {
    id: 'JE003',
    code: 'JE-2025-003',
    entryDate: '2025-01-15',
    status: 'submitted',
    entryType: '급여분개',
    items: [
      {
        id: 'JEI006',
        accountId: 'ACC052',
        accountCode: '5200',
        accountName: '급여',
        debit: 16000000,
        credit: 0,
        description: '1월 공장 직원 급여',
      },
      {
        id: 'JEI007',
        accountId: 'ACC004',
        accountCode: '1120',
        accountName: '보통예금 - 농협은행',
        debit: 0,
        credit: 14400000,
        description: '급여 지급',
      },
      {
        id: 'JEI008',
        accountId: 'ACC024',
        accountCode: '2130',
        accountName: '예수금',
        debit: 0,
        credit: 1600000,
        description: '4대보험 및 세금',
      },
    ],
    totalDebit: 16000000,
    totalCredit: 16000000,
    remarks: '1월 급여 지급',
    createdBy: '김회계',
    createdAt: '2025-01-15',
    updatedAt: '2025-01-15',
  },
  {
    id: 'JE004',
    code: 'JE-2025-004',
    entryDate: '2025-01-20',
    status: 'submitted',
    entryType: '매출분개',
    items: [
      {
        id: 'JEI009',
        accountId: 'ACC006',
        accountCode: '1200',
        accountName: '매출채권',
        debit: 5500000,
        credit: 0,
        description: '논산딸기영농조합 딸기박스 매출',
      },
      {
        id: 'JEI010',
        accountId: 'ACC041',
        accountCode: '4100',
        accountName: '박스 매출',
        debit: 0,
        credit: 5000000,
        description: '딸기박스 3kg 판매',
      },
      {
        id: 'JEI011',
        accountId: 'ACC024',
        accountCode: '2130',
        accountName: '예수금',
        debit: 0,
        credit: 500000,
        description: '부가세 예수금',
      },
    ],
    totalDebit: 5500000,
    totalCredit: 5500000,
    reference: 'INV-2025-003',
    remarks: '논산딸기영농조합 딸기박스 매출',
    createdBy: '김회계',
    createdAt: '2025-01-20',
    updatedAt: '2025-01-20',
  },
  {
    id: 'JE005',
    code: 'JE-2025-005',
    entryDate: '2025-01-25',
    status: 'draft',
    entryType: '일반분개',
    items: [
      {
        id: 'JEI012',
        accountId: 'ACC055',
        accountCode: '5500',
        accountName: '부자재비 (잉크/풀)',
        debit: 3500000,
        credit: 0,
        description: '인쇄 잉크 및 전분 풀 구입',
      },
      {
        id: 'JEI013',
        accountId: 'ACC004',
        accountCode: '1120',
        accountName: '보통예금 - 농협은행',
        debit: 0,
        credit: 3500000,
        description: '동아잉크/삼진화학 대금',
      },
    ],
    totalDebit: 3500000,
    totalCredit: 3500000,
    remarks: '부자재 구입',
    createdBy: '김회계',
    createdAt: '2025-01-25',
    updatedAt: '2025-01-25',
  },
];

// 결제
export const paymentEntries: PaymentEntry[] = [
  {
    id: 'PE001',
    code: 'PE-2025-001',
    paymentDate: '2025-01-08',
    paymentType: 'receive',
    partyType: 'customer',
    partyId: 'CUST002',
    partyName: '서귀포감귤농협',
    paymentMethod: 'bank_transfer',
    status: 'submitted',
    paidToAccount: '보통예금 - 농협은행',
    amount: 8800000,
    reference: 'INV-2025-001',
    remarks: '감귤박스 대금 수금',
    createdAt: '2025-01-08',
    updatedAt: '2025-01-08',
  },
  {
    id: 'PE002',
    code: 'PE-2025-002',
    paymentDate: '2025-01-12',
    paymentType: 'pay',
    partyType: 'supplier',
    partyId: 'SUP001',
    partyName: '(주)한국제지',
    paymentMethod: 'bank_transfer',
    status: 'submitted',
    paidFromAccount: '보통예금 - 농협은행',
    amount: 16500000,
    reference: 'PINV-2025-001',
    remarks: '원지 대금 지급',
    createdAt: '2025-01-12',
    updatedAt: '2025-01-12',
  },
  {
    id: 'PE003',
    code: 'PE-2025-003',
    paymentDate: '2025-01-18',
    paymentType: 'receive',
    partyType: 'customer',
    partyId: 'CUST001',
    partyName: '충주사과영농조합',
    paymentMethod: 'bank_transfer',
    status: 'submitted',
    paidToAccount: '보통예금 - 기업은행',
    amount: 12500000,
    reference: 'INV-2025-002',
    remarks: '사과박스 대금 수금',
    createdAt: '2025-01-18',
    updatedAt: '2025-01-18',
  },
  {
    id: 'PE004',
    code: 'PE-2025-004',
    paymentDate: '2025-01-22',
    paymentType: 'internal_transfer',
    paymentMethod: 'bank_transfer',
    status: 'submitted',
    paidFromAccount: '보통예금 - 기업은행',
    paidToAccount: '보통예금 - 농협은행',
    amount: 15000000,
    remarks: '계좌 간 이체 (설비 투자금)',
    createdAt: '2025-01-22',
    updatedAt: '2025-01-22',
  },
  {
    id: 'PE005',
    code: 'PE-2025-005',
    paymentDate: '2025-01-25',
    paymentType: 'pay',
    partyType: 'supplier',
    partyId: 'SUP005',
    partyName: '중앙골판지',
    paymentMethod: 'bank_transfer',
    status: 'draft',
    paidFromAccount: '보통예금 - 농협은행',
    amount: 8800000,
    reference: 'PINV-2025-003',
    remarks: '골판지 원단 대금 지급',
    createdAt: '2025-01-25',
    updatedAt: '2025-01-25',
  },
];

// 은행 거래
export const bankTransactions: BankTransaction[] = [
  {
    id: 'BT001',
    transactionDate: '2025-01-02',
    bankAccount: 'ACC004',
    bankAccountName: '보통예금 - 농협은행',
    transactionType: 'deposit',
    amount: 60000000,
    balance: 60000000,
    description: '기초 잔액',
    isReconciled: true,
    reconciledDate: '2025-01-02',
  },
  {
    id: 'BT002',
    transactionDate: '2025-01-08',
    bankAccount: 'ACC004',
    bankAccountName: '보통예금 - 농협은행',
    transactionType: 'deposit',
    amount: 8800000,
    balance: 68800000,
    description: '서귀포감귤농협 감귤박스 대금 입금',
    reference: 'PE-2025-001',
    isReconciled: true,
    reconciledDate: '2025-01-08',
  },
  {
    id: 'BT003',
    transactionDate: '2025-01-12',
    bankAccount: 'ACC004',
    bankAccountName: '보통예금 - 농협은행',
    transactionType: 'withdrawal',
    amount: 16500000,
    balance: 52300000,
    description: '(주)한국제지 원지 대금 지급',
    reference: 'PE-2025-002',
    isReconciled: true,
    reconciledDate: '2025-01-12',
  },
  {
    id: 'BT004',
    transactionDate: '2025-01-15',
    bankAccount: 'ACC004',
    bankAccountName: '보통예금 - 농협은행',
    transactionType: 'withdrawal',
    amount: 14400000,
    balance: 37900000,
    description: '1월 공장 직원 급여 지급',
    reference: 'JE-2025-003',
    isReconciled: true,
    reconciledDate: '2025-01-15',
  },
  {
    id: 'BT005',
    transactionDate: '2025-01-18',
    bankAccount: 'ACC005',
    bankAccountName: '보통예금 - 기업은행',
    transactionType: 'deposit',
    amount: 12500000,
    balance: 42500000,
    description: '충주사과영농조합 사과박스 대금 입금',
    reference: 'PE-2025-003',
    isReconciled: true,
    reconciledDate: '2025-01-18',
  },
  {
    id: 'BT006',
    transactionDate: '2025-01-22',
    bankAccount: 'ACC005',
    bankAccountName: '보통예금 - 기업은행',
    transactionType: 'withdrawal',
    amount: 15000000,
    balance: 27500000,
    description: '농협은행으로 이체 (설비 투자금)',
    reference: 'PE-2025-004',
    isReconciled: false,
  },
  {
    id: 'BT007',
    transactionDate: '2025-01-22',
    bankAccount: 'ACC004',
    bankAccountName: '보통예금 - 농협은행',
    transactionType: 'deposit',
    amount: 15000000,
    balance: 52900000,
    description: '기업은행에서 입금 (설비 투자금)',
    reference: 'PE-2025-004',
    isReconciled: false,
  },
  {
    id: 'BT008',
    transactionDate: '2025-01-25',
    bankAccount: 'ACC004',
    bankAccountName: '보통예금 - 농협은행',
    transactionType: 'withdrawal',
    amount: 3500000,
    balance: 49400000,
    description: '부자재 대금 지급 (잉크/풀)',
    reference: 'JE-2025-005',
    isReconciled: false,
  },
];

// 헬퍼 함수들
export const getAccountById = (id: string): Account | undefined => {
  return accounts.find((a) => a.id === id);
};

export const getAccountByCode = (code: string): Account | undefined => {
  return accounts.find((a) => a.code === code);
};

export const getJournalEntryById = (id: string): JournalEntry | undefined => {
  return journalEntries.find((je) => je.id === id);
};

export const getPaymentEntryById = (id: string): PaymentEntry | undefined => {
  return paymentEntries.find((pe) => pe.id === id);
};

// 통계 헬퍼
export const getAccountsStats = () => {
  const totalAssets = accounts
    .filter((a) => a.accountType === 'asset' && !a.isGroup)
    .reduce((sum, a) => sum + a.balance, 0);

  const totalLiabilities = accounts
    .filter((a) => a.accountType === 'liability' && !a.isGroup)
    .reduce((sum, a) => sum + a.balance, 0);

  const totalEquity = accounts
    .filter((a) => a.accountType === 'equity' && !a.isGroup)
    .reduce((sum, a) => sum + a.balance, 0);

  const totalIncome = accounts
    .filter((a) => a.accountType === 'income' && !a.isGroup)
    .reduce((sum, a) => sum + a.balance, 0);

  const totalExpense = accounts
    .filter((a) => a.accountType === 'expense' && !a.isGroup)
    .reduce((sum, a) => sum + a.balance, 0);

  const totalReceivable = accounts
    .filter((a) => a.subType === 'receivable')
    .reduce((sum, a) => sum + a.balance, 0);

  const totalPayable = accounts
    .filter((a) => a.subType === 'payable')
    .reduce((sum, a) => sum + a.balance, 0);

  const bankBalance = accounts
    .filter((a) => a.subType === 'bank' || a.subType === 'cash')
    .reduce((sum, a) => sum + a.balance, 0);

  return {
    totalAssets,
    totalLiabilities,
    totalEquity,
    totalIncome,
    totalExpense,
    netIncome: totalIncome - totalExpense,
    totalReceivable,
    totalPayable,
    bankBalance,
  };
};

// 재무제표 데이터 생성
export const getBalanceSheetData = () => {
  const stats = getAccountsStats();

  return {
    asOf: '2025-01-31',
    assets: {
      currentAssets: [
        { accountCode: '1110', accountName: '현금', amount: 12000000 },
        { accountCode: '1120', accountName: '보통예금 - 농협은행', amount: 95000000 },
        { accountCode: '1130', accountName: '보통예금 - 기업은행', amount: 48000000 },
        { accountCode: '1200', accountName: '매출채권', amount: 42500000 },
        { accountCode: '1300', accountName: '재고자산 (원지/골판지/완제품)', amount: 68000000 },
      ],
      totalCurrentAssets: 265500000,
      fixedAssets: [
        { accountCode: '1510', accountName: '공장건물', amount: 280000000 },
        { accountCode: '1520', accountName: '제조설비 (인쇄기/제함기)', amount: 150000000 },
        { accountCode: '1530', accountName: '운반차량', amount: 45000000 },
      ],
      totalFixedAssets: 475000000,
      totalAssets: stats.totalAssets,
    },
    liabilities: {
      currentLiabilities: [
        { accountCode: '2110', accountName: '매입채무 (원자재)', amount: 45000000 },
        { accountCode: '2120', accountName: '미지급금', amount: 15000000 },
        { accountCode: '2130', accountName: '예수금', amount: 9500000 },
      ],
      totalCurrentLiabilities: 69500000,
      longTermLiabilities: [
        { accountCode: '2210', accountName: '장기차입금 (설비투자)', amount: 120000000 },
      ],
      totalLongTermLiabilities: 120000000,
      totalLiabilities: stats.totalLiabilities,
    },
    equity: {
      items: [
        { accountCode: '3100', accountName: '자본금', amount: 450000000 },
        { accountCode: '3200', accountName: '이익잉여금', amount: 101000000 },
      ],
      totalEquity: stats.totalEquity,
    },
  };
};

export const getIncomeStatementData = () => {
  const stats = getAccountsStats();

  return {
    periodStart: '2025-01-01',
    periodEnd: '2025-01-31',
    revenue: {
      items: [
        { accountCode: '4100', accountName: '박스 매출', amount: 185000000 },
        { accountCode: '4200', accountName: '영업외수익', amount: 2500000 },
      ],
      totalRevenue: stats.totalIncome,
    },
    costOfGoodsSold: {
      items: [
        { accountCode: '5100', accountName: '원재료비 (원지/골판지)', amount: 95000000 },
      ],
      totalCOGS: 95000000,
    },
    grossProfit: 185000000 - 95000000,
    operatingExpenses: {
      items: [
        { accountCode: '5200', accountName: '급여', amount: 32000000 },
        { accountCode: '5300', accountName: '공장 임차료', amount: 6000000 },
        { accountCode: '5400', accountName: '감가상각비', amount: 8000000 },
        { accountCode: '5500', accountName: '부자재비 (잉크/풀)', amount: 12000000 },
      ],
      totalOperatingExpenses: 58000000,
    },
    operatingIncome: 90000000 - 58000000,
    otherExpenses: {
      items: [
        { accountCode: '5600', accountName: '이자비용', amount: 4500000 },
      ],
      totalOtherExpenses: 4500000,
    },
    netIncome: stats.netIncome,
  };
};
